import { isAndroid } from './env';
import { isCordova } from './env';
import { isIOS }     from './env';
import { isWeb }     from './env';

export function isSupported() {
  if (isCordova() && isIOS())
    return !!window.plugins?.socialsharing;
  else if (isCordova() && isAndroid())
    return !!navigator.share; // android plugin provides this, but different than native navigator.share
  else if (isWeb())
    return !!navigator.share;
  else
    return false;
}

export function share(options) {
  if (isCordova() && isIOS())
    return iosShare(options);
  else if (isCordova() && isAndroid())
    return androidShare(options);
  else if (isWeb())
    return webShare(options);
  else
    throw new Error('Share is not supported on this device.');
}


async function webShare({ url, text, title }) {
  return await navigator.share({ url, text, title });
}

async function iosShare({ url, text, title }) {
  return new Promise((resolve, reject) => {
    const options = {
      message: text,
      subject: title,
      url
    };
    window.plugins.socialsharing.shareWithOptions(options, resolve, reject);
  });
}

async function androidShare({ url, text, title }) {
  // https://github.com/markmarijnissen/cordova-plugin-share/blob/master/www/share.js
  return new Promise((resolve, reject) => {
    const textWithUrl = [ text, url ].join('\n\n');
    const mimeType    = 'text/plain';
    navigator.share(textWithUrl, title, mimeType, resolve, reject);
  });
}
